module.exports = __webpack_public_path__ + "img/copa_plata.6cc428f8.png";